import axios from 'axios'
import $ from 'jquery'
import url from './url.js'
import 'jquery-confirm/dist/jquery-confirm.min.js'
import 'jquery-confirm/dist/jquery-confirm.min.css'

var numberOfPending = 0
var errorAlert = false

axios.defaults.baseURL = url.baseUrl
// axios.defaults.baseURL = '/api'

axios.interceptors.request.use(
  config => {
    numberOfPending++
    if (process.browser) {
      $('.fc-loading').show()
    }
    if (config.url.indexOf(url.address) > -1) {
      return config
    }
    var token = 'token'

    if (process.browser) {
      const loginInfo = sessionStorage.getItem('loginInfo')
      if (loginInfo !== null && loginInfo !== undefined && loginInfo !== 'undefined' && loginInfo !== 'null') {
        let info = JSON.parse(sessionStorage.getItem('loginInfo'))
        token = info.Token
      }
    }
    config.headers['Content-Type'] = 'application/json;charset=utf-8'

    var exdata = config.data
    if (typeof (exdata) === 'object' && Object.prototype.toString.call(exdata).toLowerCase() === '[object object]' && !exdata.length) {
    } else if (exdata !== undefined && exdata !== '') {
      exdata = JSON.parse(exdata)
    }
    var randomNumber = ''
    if (process.browser) {
      randomNumber = localStorage.getItem('tokenId')
      if (randomNumber === null || randomNumber === undefined) {
        randomNumber = ''
      }
    } else {
      randomNumber = ''
    }
    if (randomNumber === '' && process.browser) {
      randomNumber = 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
        var r = Math.random() * 16 | 0
        return r.toString(16)
      })
      localStorage.setItem('tokenId', randomNumber)
    }
    config.data = {
      CompanyId: 5,
      Token: token,
      Data: {
        BrowserRandomNumber: randomNumber,
        ...exdata
      }
    }

    return config
  }
)
axios.interceptors.response.use(
  response => {
    numberOfPending--
    errorAlert = false
    if (numberOfPending <= 0) {
      if (process.browser) {
        $('.fc-loading').hide()
      }
    }
    if (response.data.Status === 'Success') {
      return response.data.Data
    } else {
      if (process.browser) {
        $.alert({
          title: 'Fail',
          content: response.data.Message,
          type: 'red',
          useBootstrap: false
        })
      }
      return Promise.reject(response.data.Message)
    }
  },
  error => {
    numberOfPending--
    if (numberOfPending <= 0) {
      if (process.browser) {
        $('.fc-loading').hide()
      }
    }
    if (errorAlert) {
      return Promise.reject(error)
    }
    if (error.message === 'cancel') {
      return Promise.reject(error)
    }
    errorAlert = true
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (process.browser) {
            sessionStorage.removeItem('loginInfo')
            window.location.href = '/'
          }
          break
        case 400:
          if (error.response.data != null && error.response.data.error_description != null) {
            if (process.browser) {
              $.alert({
                title: 'Fail',
                content: error.response.data.error_description,
                type: 'red',
                useBootstrap: false
              })
            }
          }
          break
        default:
          if (process.browser) {
            $.alert({
              title: 'Fail',
              content: 'Network Error',
              type: 'red',
              useBootstrap: false
            })
          }
          break
      }
    } else {
      if (process.browser) {
        $.alert({
          title: 'Fail',
          content: 'Network Error',
          type: 'red',
          useBootstrap: false
        })
      }
    }
    return Promise.reject(error)
  }
)
export default{

}



// WEBPACK FOOTER //
// ./src/api/index.js